import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100% - 90px);
  display: flex;
  align-items: center;
  background: #2c2c2c;
  justify-content: center;
`;
